import React from "react";
import { FieldGroup } from "../../components";

import "./card-type.scss";

export function MarketplaceFeeType({ value, onChange, readOnly }) {
  return (
    <div className="card-type">
      <FieldGroup
        name="card_type"
        type="select"
        options={[
          {
            id: "watch-collecting",
            name: (
              <div>
                <img
                  src="/assets/watchcollecting-logo.png"
                  height="30px"
                  width="60px"
                />
              </div>
            ),
          },
          {
            id: "watch-finder",
            name: (
              <div>
                <img
                  src="/assets/watchfinder-logo.png"
                  height="30px"
                  width="60px"
                />
              </div>
            ),
          },
          {
            id: "ebay",
            name: (
              <div>
                <img src="/assets/ebay-logo.png" height="30px" width="60px" />
              </div>
            ),
          },
          {
            id: "chrono24",
            name: (
              <div>
                <img
                  src="/assets/chrono24-logo.jpg"
                  height="30px"
                  width="60px"
                />
              </div>
            ),
          },
        ]}
        placeholder=""
        value={value}
        onChange={onChange}
        noFormik
        disabled={readOnly}
      />
    </div>
  );
}
